/**
 * Google Analytics 4 + Meta (Facebook) Pixel event tracking helper.
 * Safe no-op if either is blocked (e.g. ad blocker active).
 */

const isGtagAvailable = () =>
  typeof window !== "undefined" && typeof window.gtag === "function";

const isFbqAvailable = () =>
  typeof window !== "undefined" && typeof window.fbq === "function";

export const trackEvent = (eventName, params = {}) => {
  if (!isGtagAvailable()) return;
  window.gtag("event", eventName, params);
};

const trackFbEvent = (eventName, params = {}) => {
  if (!isFbqAvailable()) return;
  window.fbq("track", eventName, params);
};

/** Sporing af nøgle-funnel-events i MinFesttale */

// Bruger starter på formularen (Step 0)
export const trackFormStart = () => trackEvent("form_start", { form_name: "speech_form" });

// Email verificeret — bruger er nu engageret
export const trackEmailVerified = () => {
  trackEvent("email_verified", { method: "code" });
  trackFbEvent("CompleteRegistration", { content_name: "email_verified" });
};

// Tale genereret — vigtig konvertering før paywall
export const trackSpeechGenerated = (lengthType) => {
  trackEvent("speech_generated", { length_type: lengthType });
  trackFbEvent("Lead", { content_name: "speech_generated", content_category: lengthType });
};

// Stripe checkout startet
export const trackCheckoutStarted = (priceDkk, lengthType) => {
  trackEvent("begin_checkout", {
    currency: "DKK",
    value: priceDkk,
    items: [{ item_name: `Festtale (${lengthType})`, price: priceDkk, quantity: 1 }],
  });
  trackFbEvent("InitiateCheckout", {
    value: priceDkk,
    currency: "DKK",
    content_name: `Festtale (${lengthType})`,
    content_type: "product",
  });
};

// Køb gennemført (kald på Success page)
export const trackPurchase = (orderId, priceDkk, lengthType) => {
  trackEvent("purchase", {
    transaction_id: orderId,
    currency: "DKK",
    value: priceDkk,
    items: [{ item_name: `Festtale (${lengthType})`, price: priceDkk, quantity: 1 }],
  });
  trackFbEvent("Purchase", {
    value: priceDkk,
    currency: "DKK",
    content_name: `Festtale (${lengthType})`,
    content_type: "product",
    content_ids: [orderId],
    num_items: 1,
  });
};

// Nyhedsbrev signup
export const trackNewsletterSignup = () => {
  trackEvent("newsletter_signup");
  trackFbEvent("Subscribe");
};

// PDF download
export const trackPdfDownload = () => trackEvent("pdf_download");
